import {Select as SelectAntd, type SelectProps as SelectAntdProps} from 'antd'
import React, {useEffect, useRef} from 'react'
export type SelectProps = SelectAntdProps & {
  prefix?: string
}

const Select = (props: SelectProps) => {
  const r = useRef<any>(null)

  const addPrefix = () => {
    if (r.current?.nativeElement?.querySelector('.astro-ui-label-text')) {
      return
    }

    const label = document.createElement('span')
    label.className =
      props?.mode === 'multiple' ? 'astro-ui-label-text input-prefix-mul' : 'astro-ui-label-text input-prefix'
    label.innerHTML = props.prefix || ''
    r.current?.nativeElement
      ?.querySelector('.ant-select-selector')
      ?.insertBefore(label, r.current?.nativeElement?.querySelector('.ant-select-selector')?.firstChild)
  }

  useEffect(() => {
    if (props.prefix) {
      addPrefix()
    }
  }, [props.prefix])
  return (
    <SelectAntd
      ref={r}
      // defaultValue={props.prefix ? '' : undefined}
      // labelRender={(label) => (
      //   <>
      //     {props.prefix ? (
      //       <LabelText inputLabel={true} text={props.prefix} />
      //     ) : null}
      //     {label.label}
      //   </>
      // )}
      // suffixIcon={<ArrowIcon />}
      // dropdownRender={menu => <div style={{textIndent: '60em'}}>{menu}</div>}
      {...props}
    />
  )
}

export default Select

// prefix={<LabelText inputLabel={true} text={props.prefix} />}
